import { TourConfig } from './types';
import { WelcomeStepContent } from '@/components/Onboarding/WelcomeStepContent';
import { createElement } from 'react';

/**
 * Onboarding tour for the PDF Editor
 * Introduces users to the main features of the editor
 */
export const pdfEditorTour: TourConfig = {
  id: 'pdf-editor',
  name: 'PDF Editor Introduction',
  version: 1,
  context: 'pdf-editor',
  showProgress: true,
  allowSkip: true,
  type: 'onboarding',

  steps: [
    {
      id: 'welcome',
      target: null,
      title: 'Welcome to GetSign PDF editor!',
      content: createElement(WelcomeStepContent),
      placement: 'center',
      size: 'lg',
      disableSpotlight: true,
      nextButtonText: 'Start Tour',
      hideSkipButton: true,
    },
    {
      id: 'sidebar-fields',
      target: '[data-tour="sidebar-fields"]',
      title: 'Field Toolbar',
      content:
        'This sidebar contains all the fields you can add to your document. Drag and drop signature fields, text boxes, dates, and more onto your Document.',
      placement: 'left',
      spotlightPadding: 12,
    },
    {
      id: 'signature-fields',
      target: '[data-tour="signature-fields"]',
      title: 'Signature Fields',
      content:
        'Add signature and initials fields for signers. You can assign each field to a specific signer.',
      placement: 'left',
      spotlightPadding: 8,
    },
    {
      id: 'board-fields',
      target: '[data-tour="board-fields"]',
      title: 'Board Fields',
      content:
        'Pull data directly from your monday.com board columns. These fields auto-populate with real data.',
      placement: 'left',
      spotlightPadding: 8,
    },
    {
      id: 'standard-fields',
      target: '[data-tour="standard-fields"]',
      title: 'Standard Form Fields',
      content:
        'Add text boxes, checkboxes, dropdowns, and other form elements that signers can fill out.',
      placement: 'left',
      spotlightPadding: 8,
    },
    {
      id: 'pdf-canvas',
      target: '[data-tour="pdf-canvas"]',
      title: 'Document Canvas',
      content:
        'This is your document. Drag fields from the sidebar and drop them where you want them to appear. Click on any field to edit its properties.',
      placement: 'right',
      spotlightPadding: 16,
    },
    {
      id: 'preview-button',
      target: '[data-tour="preview-button"]',
      title: 'Preview Your Document',
      content:
        'Click Preview to see how your document will look with real data from your monday.com board.',
      placement: 'bottom',
      spotlightPadding: 8,
    },
    {
      id: 'save-button',
      target: '[data-tour="save-button"]',
      title: 'Save Your Work',
      content:
        "Don't forget to save your changes! Click Save to store your document configuration.",
      placement: 'bottom',
      spotlightPadding: 8,
      nextButtonText: 'Finish',
    },
  ],
};
